<template>
  <WelfarePage />
</template>

<script>
import WelfarePage from "./components/welfarePage.vue";

export default {
  name: "PublicWelfare",
  components: {
    WelfarePage
  }
};
</script>
